export function Brand({ compact = false }: { compact?: boolean }) {
  return <div className="brand" aria-label="AgriFlow">
    <svg className="brand-logo" viewBox="0 0 42 42" aria-hidden="true">
      <path className="brand-logo-field" d="M5 29.5C11 25 17 23 24 23c5 0 9.5 1.2 13 3.4V35H5z" />
      <path className="brand-logo-leaf" d="M21 22C11 21 8 14 8 7c8-.4 14.8 2.8 17 10.2C27.4 10 32.4 7.6 38 8c-.2 6.5-3.8 11.8-12.8 13.2" />
      <path className="brand-logo-stem" d="M23 31V18m0 1-8-7m8 5 8-5" />
    </svg>
    {!compact && <span className="brand-wordmark">Agri<span>Flow</span></span>}
  </div>;
}
